import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Checkbox} from '../../../components';
import {getClassName} from '../../../utils';
import shortid from 'shortid';

import './bulkActionBar.component.scss';

/**
 * BulkActionBar Wrapping Component
 */
class BulkActionBar extends PureComponent {

    /**
     * Constructor
     */
    constructor(props) {
        super(props);

        this.state = {
            componentId: shortid.generate()
        };
    }

    /**
     * Handle checkbox change event
     * @param value
     */
    handleCheckboxChange = (value) => {
        const {onCheckboxChange} = this.props;

        onCheckboxChange && onCheckboxChange(value);
    };

    /**
     * Render
     * @return {XML}
     */
    render() {
        const {className, isVisible, isBulkSelected, actions} = this.props;
        const {componentId} = this.state;

        const baseClassName = getClassName('bulk-action-bar', [
            {condition: className, trueClassName: className},
            {condition: isVisible, falseClassName: 'bulk-action-bar--hidden'}
        ]);

        return (
            <section className={baseClassName}>
                <div className='bulk-action-bar_checkbox'>
                    <Checkbox
                        id={`bulk-action-checkbox--${componentId}`}
                        theme='q4-blue-white'
                        isBoxOnly={true}
                        isChecked={isBulkSelected}
                        onChange={this.handleCheckboxChange}
                    />
                </div>
                <ul className='bulk-action-bar_action-list'>
                    {(actions || []).map((item) => {
                        return (
                            <li key={`bulk-action-item--${item.id}`} className='bulk-action-bar_action-item' onClick={item.onSelect}>
                                {item.icon && (<i className={`bulk-action-bar_action-icon ${item.icon}`}/>)}
                                {item.label && (<span className='bulk-action-bar_action-label'>{item.label}</span>)}
                            </li>
                        );
                    })}
                </ul>
            </section>
        );
    }
}

BulkActionBar.propTypes = {
    /**
     * A custom className to add to the component
     */
    className: PropTypes.string,

    /**
     * Used to determine visibility of the component
     */
    isVisible: PropTypes.bool,

    /**
     * Used to determine visibility of the component
     */
    isBulkSelected: PropTypes.bool,

    /**
     * Used to provide BulkActionBar with bulk actions
     */
    actions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        icon: PropTypes.string,
        label: PropTypes.string,
        onSelect: PropTypes.func.isRequired
    })).isRequired,

    /**
     * A callback for when the user checks or unchecks the bulk selection checkbox
     */
    onCheckboxChange: PropTypes.func.isRequired
};

BulkActionBar.defaultProps = {
    isVisible: false,
    actions: []
};

export default BulkActionBar;
